module.exports = "<div class=\"mbgf-col-sm-12 subscribe-box\" data-module=\"subscribe\" data-single-label=\"{{subscribe.single-label}}\">\n    <label for=\"subscribe\">{{subscribe.label}}</label>\n    [Subscribe = []]\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./js-src/markdown-editor/modules/subscribe/subscribe.html
// module id = 67
// module chunks = 0 1